(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    const backToTop = document.querySelector('.back-to-top');

  if (backToTop) {
    const toggleVisibility = () => {
      if (window.scrollY > window.innerHeight * 5) {
        backToTop.classList.add('is-visible');
      } else {
        backToTop.classList.remove('is-visible');
      }
    };

    backToTop.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    window.addEventListener('load', toggleVisibility);
  }
  } catch(e) { console.error(e); }
})();

})();
